import { stats } from '@/mocks/site';

export default function Stats() {
  return (
    <section className="relative -mt-8 z-20">
      <div className="max-w-5xl mx-auto px-4 md:px-6">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-3 md:gap-4">
          {stats.map((stat, index) => (
            <div
              key={index}
              className="bg-background-50 rounded-xl p-5 md:p-6 text-center border border-background-200/70"
            >
              <div className="w-10 h-10 mx-auto mb-3 rounded-lg bg-accent-100 flex items-center justify-center">
                <i className={`${stat.icon} text-lg text-accent-600`}></i>
              </div>
              <div className="text-xl md:text-2xl font-bold text-foreground-900 mb-1">
                {stat.value}
              </div>
              <div className="text-xs md:text-sm text-foreground-500">
                {stat.label}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}